import React from "react"

import GenericConditionSectionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/GenericConditionSectionEditor"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"
import { Checkbox, FormControlLabel, TextField } from "@material-ui/core"

type APIOutputConditionSectionEditorProps = {
	onSave: (chatBotFlowBlockRule: ChatBotFlowBlockRule) => void
	onDelete?: () => void
	chatBotFlowBlockRule: ChatBotFlowBlockRule
	hideChildSelection?: boolean
}

const APIOutputConditionSectionEditor: React.FC<APIOutputConditionSectionEditorProps> = (props) => {
	const {
		onSave,
		chatBotFlowBlockRule,
		children,
		hideChildSelection,
		onDelete
	} = props

	return (
		<GenericConditionSectionEditor
			availableValidationInputs={{
				"ai-agent-api-output": {
					title: "Campo retornado pela API do Agente",
					defaultFirstParamValue: "",
					firstParam: {
						render: ({ onChangeValidationValue, value }) => {
							const variableName = String(value).replace(/{|}/g, "")

							return (
								<TextField
									variant="outlined"
									placeholder="aiAgentResponse"
									value={variableName}
									onChange={(event) => onChangeValidationValue(`{{${event.target.value}}}`)}
									fullWidth
								/>
							)
						}
					},
					secondParam: {
						render: ({ onChangeValidationValue, value }) => (
							<TextField
								variant="outlined"
								placeholder="true"
								value={value}
								onChange={(event) => onChangeValidationValue(event.target.value)}
								fullWidth
							/>
						)
					},
					types: ["equals", "contains", "not-contains", "greater-than", "lower-than"]
				}
			}}
			footer={({ rule, changeRule }) => (
				<FormControlLabel
					control={(
						<Checkbox
							color="primary"
							checked={Boolean(rule.extra_data?.ai_agent_can_send_message_after_following_condition)}
							onChange={(_, checked) => {
								changeRule({
									extra_data: {
										...rule.extra_data,
										ai_agent_can_send_message_after_following_condition: checked
									}
								})
							}}
						/>
					)}
					label="Enviar mensagem do agente após acionar saída?"
				/>
			)}
			hideChildSelection={hideChildSelection}
			onSave={onSave}
			onDelete={onDelete}
			chatBotFlowBlockRule={chatBotFlowBlockRule}
			chatBotFlowBlockType="condition"
		>
			{children}
		</GenericConditionSectionEditor>
	)
}

export default APIOutputConditionSectionEditor
